import Index from '../components/Notification/Index'

let routes = {
    path: '/materialCategory',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/notification',
            component: Index,
            meta: {
              notification: true
            }
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/notification.js